<template>
    <projeto-resultados 
        :projeto-id="projetoIdBase" 
        :titulo="titulo" 
        :colunas="colunas" 
        :rubrica="rubrica" 
        :componente="componente" 
        :endpoint="endpoint" 
        @update="update"

        :chave-permissao="chavePermissao"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import helpers from "@/common/utils/helpers";
import ProjetoResultados from "../componentes/Resultados"
export default {
    components : {
        ProjetoResultados
    },
    props : ['projetoId', 'projetoIdBase', 'endpoint', 'chavePermissao', 'projetoEditavel'],
    data : () => ({
        colunas : [                      
            { key: 'tipo', label: "Tipo de doc.",
                formatter: (value) => {
                    if (value) return  helpers.getEnum(value).text;
                },
            },
            { key: "dataRegistro", label: "Data do registro", 
                formatter: (value) => {
                    if (value) return  helpers.formatarDataBr(value);
                },
            },
            { key: "numeroRegistro", label: "Nº do registro", },
            { key: "titulo", label: "Titulo", },
        ],
        componente : 'propriedade-intelectual',
        rubrica : 'propriedade-intelectual',
        titulo : 'Propriedade Intelectual',
    }),
    methods : {
        update : function(){
            this.$emit('update');
        }
    }
}
</script>
<style>
    
</style>